<template lang="pug">
.v-field-check-list.field-check-list(v-if="field" :class="{'field-check-list--disabled': field.disabled}")
	template(v-if="field.mode && field.mode === 'check-box'")
		label.field-check-list__label(v-if="field.label" :id="uniqueId" :class="{'field-check-list__label--active': localValue && localValue.length}")
			| {{field.label}}
			span.field-text__star(v-if="field.required") *
		.field-check-list__item.flc(v-for="(option, index) in field.options" :key="option.value + '-' + index")
			v-field-checkbox(
				:true-value="option.value"
				:text="option.text"
				:class-name="option.className"
				:disabled="option.disabled || field.disabled"
				v-model="localValue"
				@update:model-value="handleInput"
				:radio="radio")
	template(v-else)
		button.field-check-list__btn-toggle(type="button"
				:class="{'field-check-list__btn-toggle--opened': isSm ? mobOpened : desktopOpen}"
				:disabled="field.disabled"
				@click="toggle")
			v-svg-icon.field-check-list__btn-toggle-icon(v-if="!isSm" icon="small-chevron")
		label.field-check-list__label(v-if="field.label" :id="uniqueId" :class="{'field-check-list__label--active': localValue && localValue.length}")
			| {{field.label}}
			span.field-text__star(v-if="field.required") *
			v-svg-icon.field-text__arrow-right(v-if="isSm" icon="chevron-right-sm")
		.field-check-list__note(v-if="field.note") {{field.note}}
		.field-check-list__reset(v-if="!field.disabled && isSm")
			button.field-check-list__mob-reset(v-if="localValue" type="button" @click="reset") Сбросить
		.field-check-list__values-list(v-if="isSm && computedValuesList") {{computedValuesList}}
		v-collapse.field-check-list__collapse(:open="isSm ? true : (isInFilter ? desktopOpen : true)")
			.field-check-list__collapse-wrap(:class="{'field-check-list__collapse-wrap--opened': isSm ? mobOpened : desktopOpen}")
				.field-check-list__mob-header(v-if="isSm")
					button.field-check-list__close(type="button" @click="close")
						v-svg-icon.field-check-list__close-icon(icon="close")
					.field-check-list__mob-label {{field.label}}
					button.field-check-list__mob-reset(v-if="localValue" type="button" @click="reset") Сбросить
				template(v-if="field.searchable || field.searchAjax")
					.field-check-list__field-text-input-wrap
						input.field-check-list__field-text-input.field-input(ref="input"
								type="text"
								:placeholder="field.placeholder || 'Найти в списке'"
								:inputmode="field.inputmode"
								:disabled="field.disabled"
								v-model="selectValueText"
								:id="uniqueId"
								@keyup="foundSelectValue")
						v-svg-icon.field-check-list__field-text-input-icon(icon="lens")
						button.field-check-list__field-text-clean(v-if="selectValueText"
								type="button"
								@click="cleanSelectText")
							v-svg-icon.field-check-list__field-text-clean-icon(icon="close")
				template(v-if="isSm")
					.field-check-list__items
						template(v-for="(option, index) in field.options" :key="index")
							template(v-if="isFoundSelectText(option.text)")
								.field-check-list__item.flc
									v-field-checkbox(:true-value="option.value"
											:text="option.text"
											:note="option.note"
											:disabled="field.disabled"
											v-model="localValue"
											@update:model-value="handleInput"
											:radio="radio")
						.field-check-list__empty-message Ничего не найдено
					button.field-check-list__btn-apply.btn.btn--primary.btn--block(type="button" @click="apply") Применить
				template(v-else)
					.field-check-list__items
						template(v-for="(option, index) in filteredOptions" :key="index")
							.field-check-list__item.flc(v-show="(isSpoilterOpened || selectValueText) ? true : index < (field.maxVisibleOptions || Infinity)")
								v-field-checkbox(:true-value="option.value"
										:text="option.text"
										:note="option.note"
										:disabled="field.disabled"
										v-model="localValue"
										@update:model-value="handleInput"
										:radio="radio")
						.field-check-list__footer
							.field-check-list__footer-left
								button.field-check-list__spoiler-btn(v-if="selectValueText && !radio" type="button" @click="selectAll") Выбрать все
								button.field-check-list__spoiler-btn(v-if="field.maxVisibleOptions && field.options && field.options.length > field.maxVisibleOptions && !isSpoilterOpened && !selectValueText" type="button" @click="openSpoiler") Показать все
							.field-check-list__footer-right(v-if="!isSm && localValue && localValue.length")
								button.field-check-list__spoiler-btn.field-check-list__spoiler-btn--reset(type="button" @click="reset") Сбросить
</template>

<script>
import uniqueId from '../scripts/helpers/uniqueId.js';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import controller from '../scripts/controller/controller.js';

export default {
	mixins: [
		isMobMixin
	],

	props: {
		radio: {
			type: Boolean,
			default: false
		},

		field: {
			type: Object,
			required: true,
			default: null
		},

		modelValue: {
			type: [Object, String, Number],
			default: null
		},

		isInFilter: {
			type: Boolean,
			default: false
		}
	},

	emits: [
		'update:model-value'
	],

	data() {
		return {
			savedValue: null,
			localValue: null,
			uncheckedValue: [],
			isSpoilterOpened: false,
			uniqueId: uniqueId('field-'),
			selectValueText: '',
			isSelectValueFound: false,
			selectValue: null,
			desktopOpen: false,
			mobOpened: false
		};
	},

	watch: {
		modelValue() {
			this.cleanField();
			this.updateLocalValue();
		}
	},

	created() {
		this.cleanField();
		this.updateLocalValue();
		controller.events.on('open-field', this.openById);
	},

	computed: {
		filteredOptions() {
			return this.field.options.filter(option => {
				if (this.selectValueText) {
					if (option.text.toLowerCase().indexOf(this.selectValueText.toLowerCase()) !== -1) {
						return true;
					} else {
						return false;
					}
				} else {
					return true;
				}
			});
		},

		computedValuesList() {
			let result = '';
			if (this.localValue && Array.isArray(this.localValue) && this.localValue.length) {
				let list = [];
				this.localValue.forEach(value => {
					let foundValue = this.field.options.find(option => option.value === value);
					if (foundValue && foundValue.text) {
						list.push(foundValue.text);
					}
				});
				result = list.join(', ');
			} else if (this.localValue && typeof this.localValue === 'string') {
				let foundValue = this.field.options.find(option => option.value === this.localValue);
				if (foundValue && foundValue.text) {
					result = foundValue.text;
				}
			}
			return result;
		}
	},

	methods: {
		selectAll() {
			this.localValue = [];
			this.filteredOptions.forEach(filteredOption => {
				this.localValue.push(filteredOption.value);
			});
			this.handleInput();
		},

		cleanField() {
			if (this.field.disabled) {
				this.mobOpened = false;
				this.desktopOpen = false;
			}
			if (this.field.autosubmit) {
				this.selectValueText = '';
			}
		},

		reset() {
			this.selectValueText = '';
			if (this.field.type === 'check-list') {
				this.localValue = [];
			} else {
				this.localValue = null;
			}
			if (!this.radio && this.savedValue && this.localValue.length < this.savedValue.length) {
				this.uncheckedValue = [];
				this.savedValue.forEach(item => {
					if (this.localValue.indexOf(item) === -1) {
						this.uncheckedValue.push(item);
					}
				});
			}
			this.$emit('update:model-value', this.localValue, this.uncheckedValue, true);
		},

		foundSelectValue() {
			let result = false;
			if (this.field && this.field.options && this.field.options.length) {
				for (let i = 0; i < this.field.options.length; i++) {
					if (this.isFoundSelectText(this.field.options[i].text)) {
						result = this.field.options[i].text;
						this.isSelectValueFound = true;
						break;
					}
				}
				if (result) {
					this.isSelectValueFound = true;
				} else {
					this.isSelectValueFound = false;
				}
			}
			return result;
		},

		isFoundSelectText(text = '') {
			if (this.field.searchAjax) {
				return true;
			}
			let result = false;
			let selectValueText = this.selectValueText;
			if (!selectValueText) {
				selectValueText = '';
			}
			if (text.toLowerCase().indexOf(selectValueText.toLowerCase()) !== -1) {
				result = true;
			} else {
				result = false;
			}
			return result;
		},

		cleanSelectText() {
			this.selectValueText = '';
		},

		openById(id) {
			if (id === this.field.id) {
				setTimeout(() => {
					this.open();
				}, 400);
			}
		},

		toggle() {
			if (this.isSm) {
				if (this.mobOpened) {
					this.close();
				} else {
					this.open();
				}
			} else {
				if (this.desktopOpen) {
					this.close();
				} else {
					this.open();
				}
			}
		},

		open() {
			if (this.isSm) {
				this.mobOpened = true;
			} else {
				this.desktopOpen = true;
			}
		},

		close() {
			if (this.isSm) {
				this.mobOpened = false;
			} else {
				this.desktopOpen = false;
			}
		},

		openSpoiler() {
			this.isSpoilterOpened = true;
		},

		updateLocalValue() {
			if (!this.radio) {
				this.savedValue = this.modelValue;
			}
			this.localValue = this.modelValue;
		},

		handleInput() {
			if (!this.radio && this.savedValue && this.localValue.length < this.savedValue.length) {
				this.uncheckedValue = [];
				this.savedValue.forEach(item => {
					if (this.localValue.indexOf(item) === -1) {
						this.uncheckedValue.push(item);
					}
				});
			}
			this.$emit('update:model-value', this.localValue, this.uncheckedValue, this.field.autosubmit);
		},

		apply() {
			this.handleInput();
			this.close();
		}
	},
};
</script>
